import React from "react";
import { View } from "react-native";
import { fontWeights, Icon, theme, Tooltip, typography, Text } from "ui-components";
import { Grid, Container, Row, Column } from "ui-grid";
import { domusoResponsiveStyleHelper } from "../../../screens/new/utils/domuso-responsive";
import testingProps from "../../../screens/new/utils/automation-testing-locators.json";

export const PaymentHeading = ({
  heading,
  showTooltip = false,
  screenWidth,
  tooltipTitle,
  tooltipBody,
}: any) => {
  return (
    <Grid>
      <Container>
        <Row>
          <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
          <Column
            span={{ xs: 12, sm: 8, md: 8, lg: 8 }}
            style={{
              ...domusoResponsiveStyleHelper({
                webPhone: {},
                webTablet: {
                  borderTopRightRadius: 10,
                  borderTopLeftRadius: 10,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderTopWidth: 1,
                  borderTopColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",

                  background: "#FFFFFF",

                  paddingTop: 40,
                  paddingLeft: 40,
                  paddingRight: 40,
                  backgroundColor: "white",
                },
                webDesktop: {
                  borderTopRightRadius: 10,
                  borderTopLeftRadius: 10,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderTopWidth: 1,
                  borderTopColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",

                  background: "#FFFFFF",

                  paddingTop: 40,
                  paddingLeft: 40,
                  paddingRight: 40,
                  backgroundColor: "white",
                },
                iosPhone: {},
                iosTablet: {
                  borderTopRightRadius: 10,
                  borderTopLeftRadius: 10,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderTopWidth: 1,
                  borderTopColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",

                  background: "#FFFFFF",

                  paddingTop: 40,
                  paddingLeft: 40,
                  paddingRight: 40,
                  backgroundColor: "white",
                },
                androidPhone: {},
                androidTablet: {
                  borderTopRightRadius: 10,
                  borderTopLeftRadius: 10,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderTopWidth: 1,
                  borderTopColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",

                  background: "#FFFFFF",

                  paddingTop: 40,
                  paddingLeft: 40,
                  paddingRight: 40,
                  backgroundColor: "white",
                },
              }),
            }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text
                style={[
                  typography.heading2,
                  {
                    fontWeight: fontWeights.Bold,
                    fontFamily: "Lato_700Bold",
                    color: theme.colors.secondary,
                  },
                ]}
                {...testingProps.paymentFlowPaymentDetails.paymentHeading}>
                {heading}
              </Text>
              {showTooltip && (
                <View style={{ marginLeft: 10 }}>
                  <Tooltip
                    width={"80%"}
                    title={tooltipTitle}
                    body={tooltipBody}
                    widthWeb={screenWidth > 500 ? 350 : screenWidth * 0.7}>
                    <Icon size={theme.iconSize.medium} color={theme.colors.primary} name="error" />
                  </Tooltip>
                </View>
              )}
            </View>
            <View style={{ margin: 5 }} />
          </Column>
        </Row>
      </Container>
    </Grid>
  );
};
